module.exports = __webpack_public_path__ + "img-project-noaction.981fa9d6c1fef41e9671ddfcb3aee01b.hashedasset.svg";